<div class="mb-16 list-header">
  <div class="lty-input-icon-group search-bar">
    <input
      id="filter-text-box"
      type="text"
      class="form-control lty-form-control"
      placeholder="Search"
      [formControl]="searchStringControl"
      i18n-placeholder
    />
    <div class="input-icon">
      <app-search-icon height="20px" width="20px" color="var(--gray-500)" />
    </div>
  </div>
  <div class="list-filters">
    <select
      class="form-control lty-form-control form-select"
      [(ngModel)]="filteredInsuranceType"
      *ngIf="leadsOnly"
      name="filteredInsuranceType"
    >
      <option [ngValue]="null" i18n>Type d'assurance</option>
      <option [ngValue]="value" *ngFor="let value of InsuranceTypeValues">
        {{ getInsuranceTypeLabel(value) }}
      </option>
    </select>
    <select
      class="form-control lty-form-control form-select"
      *ngIf="leadsOnly && StatusValues?.length! > 0"
      [(ngModel)]="filteredStatus"
      name="filteredLeadStatus"
    >
      <option [ngValue]="null" i18n>État</option>
      <option [ngValue]="value" *ngFor="let value of StatusValues">
        {{ getFilterLeadStatusLabel(value) }}
      </option>
    </select>
    <select
      class="form-control lty-form-control form-select"
      *ngIf="SortElementValues?.length! > 0"
      [(ngModel)]="sortBy"
      name="sortBy"
    >
      <option [ngValue]="null" i18n>Trier par</option>
      <option [ngValue]="value" *ngFor="let value of SortElementValues">
        {{ getSortElementLabel(value) }}
      </option>
    </select>
    <div class="d-flex align-items-center gap-2">
      <app-toggle [(value)]="ascending" />
      <span i18n>Ordre croissant</span>
    </div>
  </div>
</div>
<div class="dashboard-table">
  <ag-grid-angular
    style="width: 100%; height: 780px"
    class="ag-theme-alpine lty-table"
    [rowData]="displayedList"
    [pagination]="false"
    [animateRows]="false"
    (cellClicked)="onCellClicked($event)"
    [suppressRowTransform]="true"
    [suppressRowClickSelection]="true"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
    [defaultColDef]="defaultColDef"
    [context]="context"
    [overlayNoRowsTemplate]="noRowsOverlayMessage"
    [getRowId]="getRowId"
    (bodyScrollEnd)="checkRows()"
  />
</div>

<app-task-details #taskDetailsModal (updated)="simpleListReset()" />
<app-cancellation-details-modal
  [cancellationId]="openCancellationId"
  [canEdit]="canEdit"
  (closed)="openCancellationId = null"
  (changed)="simpleListReset()"
  (deleted)="simpleListReset()"
/>
